//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useLayoutEffect, useEffect, useRef, useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PlayCircleFilledWhiteRoundedIcon from '@material-ui/icons/PlayCircleFilledWhiteRounded';
import AfitdAvatarWithRing from '../../common/elemental/AfitdAvatarWithRing';

// import 'video.js/dist/video-js.min.css';
import videojs from 'video.js';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import _get from 'lodash/get';
// import _isEmpty from 'lodash/isEmpty';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},
        thumbnailContainer: {
            position: 'relative',
            display: 'flex',
            height: '100%',
            zIndex: 1,
            cursor: 'pointer',
            flexDirection: 'column',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'space-evenly',
        },
        userAvatarContainer: {
            // marginBottom: '30px',
        },
        playIcon: {
            fontSize: '80px',
            color: 'white',
            // margin: 'auto',
            [theme.breakpoints.down('md')]: {
                fontSize: '70px',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '50px',
            },
            [theme.breakpoints.down('xs')]: {
                fontSize: '40px',
            },
        },
        jobSeekerText: {
            color: theme.palette.primary.main,
            marginTop: '55px',
        },
        // videoOverViewContainer: {
        //     [theme.breakpoints.down('sm')]: { width: 255 },
        // },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
// const getDefns = params => {
//     const { classes } = params;

//     const defns = {
//         root: {},
//     };

//     setClassNameInDefns(defns, classes);
//     return defns;
// };
//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const VideoOverviewBlock = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    const videoNodeRef = useRef();
    const playerRef = useRef(null);
    const player = _get(playerRef, 'current');

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const {
        videoOverviewUrl: videoUrl,
        poster,
        videoOverviewFileType: videoType,
        onLoadedMetadata,
        vjsPlayerStyles: vjsPlayerStylesProp,
        userAvatar,
        hideThumbnail,
        onPlayVideo,
    } = props;

    // style
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));
    const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [isPlayerReady, setIsPlayerReady] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useLayoutEffect(() => {
        // console.log('%c@@@@ VideoOverviewBlock componentDidMount START', 'background: #222; color: #bada55');
        // console.log('%c@@@@ VideoOverviewBlock componentDidMount START', 'background: #222; color: #bada55');
        // console.log('%c@@@@ VideoOverviewBlock componentDidMount START', 'background: #222; color: #bada55');
        // console.log('%c@@@@ VideoOverviewBlock componentDidMount START', 'background: #222; color: #bada55');

        const videoNode = _get(videoNodeRef, 'current');
        if (videoNode) {
            // instantiate Video.js
            const videoJSOptions = {
                //   autoplay: "muted",
                //   controls: true,
                //   userActions: { hotkeys: true },
                //   playbackRates: [0.5, 1, 1.5, 2]
                // video.js options
                controls: true,
                // bigPlayButton: true,
                loop: false,
                fluid: false,
                width: 680,
                // height: 360,
                // width: 720,
                // height: 480,
                // aspectRatio: "4:3",
                // autoplay: true,
                controlBar: {
                    volumePanel: false,
                    fullscreenToggle: true,
                    pictureInPictureToggle: false,
                },
            };

            playerRef.current = videojs(videoNode, videoJSOptions, () => {
                setIsPlayerReady(true);
                // Set the URL for the video from storage
                // this.player.src('https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4');
                // this.player.src('https://firebasestorage.googleapis.com/v0/b/afitd-dev.appspot.com/o/users%2FekOVkRuQj1evtfnLsoHVfyeia632%2FvideoOverview%2Fvideo.webm?alt=media&token=ded1b5f7-6cbe-4524-bdaa-c91a6385340b');

                playerRef.current.on('error', () => {
                    // console.log('%c@@@@ videojs-record error', 'background: #222; color: #bada55');
                });

                playerRef.current.on('ended', () => {
                    console.log('ended');
                });

                // console.log('Player Ready');
            });
        }

        // destroy player on unmount
        return () => {
            // console.log('%c@@@@ VideoOverviewBlock componentWillUnmount START', 'background: #222; color: #bada55');
            const player = _get(playerRef, 'current');
            if (player) {
                player.dispose();
            }
        };
    }, [videoNodeRef]);

    useEffect(() => {
        if (isPlayerReady) {
            // console.log('%c@@@@ VideoOverviewBlock useEffect videoUrl=', 'background: #222; color: #bada55', videoUrl);

            player.on('error', () => {
                // console.log('%c@@@@ videojs-record error', 'background: #222; color: #bada55');
            });

            player.on('ended', () => {
                console.log('ended');
            });

            if (videoUrl) {
                // console.log('%c@@@@ VideoOverviewBlock useEffect setting player.src ', 'background: #222; color: #bada55');
                player.src({ src: videoUrl, type: videoType ? `video/${videoType}` : undefined });
                player.removeClass('vjs-hidden');
            } else {
                player.addClass('vjs-hidden');
            }
        }
        // setIsplaying(false)
        // if (videoUrl && player) {
        //     console.log('%c@@@@ VideoOverviewBlock useEffect setting player.src ', 'background: #222; color: #bada55');
        //     player.src({ src: videoUrl, type: videoType ? `video/${videoType}` : undefined });
        //     player.removeClass('vjs-hidden');

        //     // if (player.readyState() < 1) {
        //     //     // do not have metadata yet so loadedmetadata event not fired yet (I presume)
        //     //     // wait for loadedmetdata event
        //     //     player.one('loadedmetadata', onLoadedMetadata);
        //     // } else {
        //     //     // metadata already loaded
        //     //     onLoadedMetadata();
        //     // }

        //     // function onLoadedMetadata() {
        //     //     alert(player.duration());
        //     // }
        // }

        // if (!videoUrl && player) {
        //     player.addClass('vjs-hidden');
        // }
    }, [isPlayerReady, videoUrl, videoType, player]);

    // shouldComponentUpdate(nextProps, nextState) {
    //     if (nextProps && nextProps.videoOverviewUrl && this.props.videoOverviewUrl !== nextProps.videoOverviewUrl) {
    //         console.log('%c@@@@ VideoOverviewBlock shouldComponentUpdate TRUE START', 'background: #222; color: #bada55');
    //         console.log('%c@@@@ VideoOverviewBlock shouldComponentUpdate TRUE START', 'background: #222; color: #bada55');
    //         console.log('%c@@@@ VideoOverviewBlock shouldComponentUpdate TRUE START', 'background: #222; color: #bada55');
    //         console.log('%c@@@@ VideoOverviewBlock shouldComponentUpdate TRUE START', 'background: #222; color: #bada55');

    //         return true;
    //     }
    //     return false;
    // }

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    const handleLoadMetadata = useCallback(() => {
        // console.log('%c@@@@ VideoOverviewBlock handleLoadMetadata START', 'background: #222; color: #bada55', { videoNodeRef });
        const duration = _get(videoNodeRef, 'current.duration');
        if (duration) {
            if (onLoadedMetadata) onLoadedMetadata({ duration });
        }
    }, [videoNodeRef, onLoadedMetadata]);

    const playVideo = () => {
        player.play();
        onPlayVideo && onPlayVideo();
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    // const defns = getDefns({
    //     classes,
    // });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    // console.log('%c@@@@ VideoOverviewBlock render START', 'background: #222; color: #bada55');
    // console.log('%c@@@@ VideoOverviewBlock render START', 'background: #222; color: #bada55');
    // console.log('%c@@@@ VideoOverviewBlock render START', 'background: #222; color: #bada55');
    // console.log('%c@@@@ VideoOverviewBlock render START', 'background: #222; color: #bada55');

    return (
        <div>
            {smMatches ? (
                <div data-vjs-player style={{ width: 300, height: 220, ...vjsPlayerStylesProp }}>
                    <video
                        onLoadedMetadata={handleLoadMetadata}
                        ref={videoNodeRef}
                        poster={poster ? poster : '˝'}
                        id="vjs_videoOverviewBlock"
                        class="video-js vjs-default-skin vjs-big-play-centered vjs-show-big-play-button-on-pause vjs-hidden"
                    ></video>
                    {!hideThumbnail && (
                        <div className={classes.thumbnailContainer}>
                            <div className={classes.userAvatarContainer}>
                                <AfitdAvatarWithRing src={userAvatar} photoSize={60} borderSize={4} placeholderFontSize={30} alt={'Profile Picture'} />
                            </div>
                            <PlayCircleFilledWhiteRoundedIcon className={classes.playIcon} onClick={playVideo} />
                            <AfitdTypography color="primary" variant="h5" className={classes.jobSeekerText}>
                                Job Seeker Profile Video
                            </AfitdTypography>
                        </div>
                    )}
                </div>
            ) : mdMatches ? (
                <div data-vjs-player style={{ width: 430, height: 280, ...vjsPlayerStylesProp }}>
                    <video
                        onLoadedMetadata={handleLoadMetadata}
                        ref={videoNodeRef}
                        poster={poster ? poster : '˝'}
                        id="vjs_videoOverviewBlock"
                        class="video-js vjs-default-skin vjs-big-play-centered vjs-show-big-play-button-on-pause vjs-hidden"
                    ></video>
                    {!hideThumbnail && (
                        <div className={classes.thumbnailContainer}>
                            {userAvatar && (
                                <div className={classes.userAvatarContainer}>
                                    <AfitdAvatarWithRing src={userAvatar} photoSize={60} borderSize={4} placeholderFontSize={30} alt={'Profile Picture'} />
                                </div>
                            )}
                            <PlayCircleFilledWhiteRoundedIcon className={classes.playIcon} onClick={playVideo} />
                            <AfitdTypography color="primary" variant="h5" className={classes.jobSeekerText}>
                                Job Seeker Profile Video
                            </AfitdTypography>
                        </div>
                    )}
                </div>
            ) : lgMatches ? (
                <div data-vjs-player style={{ height: 320, ...vjsPlayerStylesProp }}>
                    <video
                        onLoadedMetadata={handleLoadMetadata}
                        ref={videoNodeRef}
                        poster={poster ? poster : '˝'}
                        id="vjs_videoOverviewBlock"
                        class="video-js vjs-default-skin vjs-big-play-centered vjs-show-big-play-button-on-pause vjs-hidden"
                    ></video>
                    {!hideThumbnail && (
                        <div className={classes.thumbnailContainer}>
                            <div className={classes.userAvatarContainer}>
                                <AfitdAvatarWithRing src={userAvatar} photoSize={70} borderSize={4} placeholderFontSize={30} alt={'Profile Picture'} />
                            </div>
                            <PlayCircleFilledWhiteRoundedIcon className={classes.playIcon} onClick={playVideo} />
                            <AfitdTypography color="primary" variant="h5" className={classes.jobSeekerText}>
                                Job Seeker Profile Video
                            </AfitdTypography>
                        </div>
                    )}
                </div>
            ) : (
                <div data-vjs-player style={{ maxHeight: 400, ...vjsPlayerStylesProp }}>
                    <video
                        onLoadedMetadata={handleLoadMetadata}
                        ref={videoNodeRef}
                        poster={poster ? poster : '˝'}
                        id="vjs_videoOverviewBlock"
                        class="video-js vjs-default-skin vjs-big-play-centered vjs-show-big-play-button-on-pause vjs-hidden"
                    ></video>
                    {!hideThumbnail && (
                        <div className={classes.thumbnailContainer}>
                            <div className={classes.userAvatarContainer}>
                                <AfitdAvatarWithRing src={userAvatar} photoSize={92} borderSize={4} placeholderFontSize={30} alt={'Profile Picture'} />
                            </div>
                            <PlayCircleFilledWhiteRoundedIcon className={classes.playIcon} onClick={playVideo} />
                            <AfitdTypography color="primary" variant="h5" className={classes.jobSeekerText}>
                                Job Seeker Profile Video
                            </AfitdTypography>
                        </div>
                    )}
                </div>
            )}{' '}
        </div>
    );
};

export default VideoOverviewBlock;
